import _styled from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import parseCustomHtmlToReact from "../../Custom/parseCustomHtmlToReact";
import styled from "styled-components";
import Box from "../../../Styled/Box";
import Text from "../../../Styled/Text";
import { jsx as _jsx } from "react/jsx-runtime";
const StoryContainer = styled(Box).attrs(props => ({
  paddedVertically: props.isCollapsed ? 0 : 2,
  scroll: true
})).withConfig({
  displayName: "StoryBody__StoryContainer",
  componentId: "sc-1m0mgng-0"
})(["background-color:", " backdrop-filter:", " padding-top:0;padding:", "px;max-height:", ";@media (min-height:700px){max-height:", ";}overflow-y:auto;transition:max-height 0.2s,padding 0.2s;img{max-width:100%;}*{max-width:100%;overflow-wrap:break-word;word-wrap:break-word;-ms-word-break:break-all;word-break:break-all;word-break:break-word;-ms-hyphens:auto;-moz-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;}"], props => props.theme.transparentDark, props => props.theme.blur, props => props.isCollapsed ? 0 : 15, props => props.isCollapsed ? 0 : "100px", props => props.isCollapsed ? 0 : "200px");
function shouldAddIframeTag(story) {
  const parser = new DOMParser();
  const parsedDocument = parser.parseFromString(story.text, "text/html");
  const iframes = parsedDocument.getElementsByTagName("iframe");
  if (iframes.length < 1) return false;
  let result = true;
  for (const iframe of iframes) {
    var _iframe$src, _iframe$src2, _iframe$src3;
    if (!((_iframe$src = iframe.src) !== null && _iframe$src !== void 0 && _iframe$src.startsWith("https://www.youtube.com/embed/") || (_iframe$src2 = iframe.src) !== null && _iframe$src2 !== void 0 && _iframe$src2.startsWith("https://www.youtube-nocookie.com/embed/") || (_iframe$src3 = iframe.src) !== null && _iframe$src3 !== void 0 && _iframe$src3.startsWith("https://player.vimeo.com/video/"))) {
      result = false;
      break;
    }
  }
  return result;
}
function sourceBasedParse(story) {
  if (shouldAddIframeTag(story)) {
    return parseCustomHtmlToReact(story.text, {
      showExternalLinkWarning: true
    }, false, {
      ADD_TAGS: ["iframe"]
    });
  } else {
    return parseCustomHtmlToReact(story.text, {
      showExternalLinkWarning: true
    }, false, {});
  }
}
const StoryBody = _ref => {
  let {
    isCollapsed,
    story
  } = _ref;
  return story.text && story.text !== "" ? /*#__PURE__*/_jsx(StoryContainer, {
    isCollapsed: isCollapsed,
    column: true,
    children: /*#__PURE__*/_jsx(_StyledText, {
      medium: true,
      children: sourceBasedParse(story)
    })
  }) : null;
};
export default StoryBody;
var _StyledText = styled(Text).withConfig({
  displayName: "StoryBody___StyledText",
  componentId: "sc-1m0mgng-1"
})(["display:flex;flex-direction:column;gap:5px;"]);